import { Text } from '@vkontakte/vkui';
import React, { memo, useCallback, useEffect } from 'react';
import { IS_ANDROID_MOBILE, IS_IOS_MOBILE } from 'reactApp/appHelpers/configHelpers';
import { marchPromo2026AnalyticsName, marchPromo2026Config } from 'reactApp/appHelpers/featuresHelpers/features/marchPromo2026';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { checkMobileWebviewPayAvailable } from 'reactApp/modules/billing/billing.helpers';
import { sendAnalytics } from 'reactApp/sections/MobileSubscriptionsPage/Discounts/Components/DiscountCard/DiscountCard.helpers';
import { revealPlatformPopup } from 'reactApp/sections/QuotaLanding/TariffsPlans/TariffPlansCard/TariffPlansCard.helpers';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { sendDwh, sendXray } from 'reactApp/utils/ga';
import { getPlatformInfo } from 'reactApp/utils/gaHelpers';
import opener from 'reactApp/utils/opener';

import styles from './DiscountCardMarchPromo2026.css';

const source = 'discounts';
const platform = getPlatformInfo().join('_');

const handleButtonShow = () => {
    sendXray([`pr0326-d-b-1tb3-shw`, platform], null, { sendImmediately: true });
    sendDwh({
        eventCategory: 'button',
        action: 'show',
        dwhData: {
            source,
            name: marchPromo2026AnalyticsName,
            platform,
        },
    });
};

const handleTermsClick = () => {
    opener(marchPromo2026Config.termsLink, true);
};

export const DiscountCardMarchPromo2026 = memo(function DiscountCardMarchPromo2026() {
    const isMobilePayAvailable = checkMobileWebviewPayAvailable();
    const isIOSPromo = IS_IOS_MOBILE;
    const isAndroidPromo = IS_ANDROID_MOBILE;

    const handleClick = useCallback(() => {
        if ((IS_IOS_MOBILE || IS_ANDROID_MOBILE) && !isMobilePayAvailable) {
            revealPlatformPopup(marchPromo2026Config.productId, isIOSPromo, isAndroidPromo);
            return;
        }

        sendXray([`pr0326-d-b-1tb3-clk`, platform], null, { sendImmediately: true });
        sendDwh({
            eventCategory: 'button',
            action: 'click',
            dwhData: {
                source,
                name: marchPromo2026AnalyticsName,
                platform,
            },
        });
        sendAnalytics('action-click', 'march_promo_2026');

        const link = `${window.location.pathname}?webview=true&${marchPromo2026Config.discountBtnLink}`;
        opener(link, true);
    }, []);

    useEffect(() => {
        handleButtonShow();
    }, []);

    return (
        <div className={styles.root} style={{ backgroundImage: `url(${cdnPackagesUrl}/static/cloud/promo/march2026/webview/modal.webp)` }}>
            <Text className={styles.title}>Увеличьте память телефона с&nbsp;Mail&nbsp;Space</Text>
            <Text className={styles.text} onClick={handleTermsClick}>
                Акция Ого-го-Облако до 27 апреля
            </Text>
            <div className={styles.button_root}>
                <Button primary theme="vk" sizeMode={ButtonSizeMode.small} className={styles.button} onClick={handleClick}>
                    Забрать 1 ТБ на 3 месяца
                </Button>
                <img
                    src={`${cdnPackagesUrl}/static/cloud/promo/march2026/mobile/sale_label.webp`}
                    className={styles.button_label}
                    alt="бесплатно"
                />
            </div>
        </div>
    );
});
